import {HTTP} from './common'

export const ParserApi = {
  get() {
    return HTTP.get(`parsers/`).then(response => {
      return response.data
    });
  },
  get_parser(id) {
    return HTTP.get(`parsers/${id}/`).then(response => {
      return response.data
    });
  },
  get_stat(id) {
    return HTTP.get(`parsers/${id}/get_stat/`).then(response => {
      return response.data
    });
  },
  start_parser(data) {
    return HTTP.post(`parsers/start_parser/`, data).then(response => {
      return response.data
    });
  },
  preload_file(data) {
    return HTTP.post(`parsers/preload_file/`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
      return response.data
    });
  },
};

